import React, { useEffect, useState } from 'react';
import { useApi } from '../context/ApiProvider';
import PageHeader from '../components/PageHeader';
import defaultArt from '../assets/images/dj_kip_art.png';
import TracksTable from '../components/TracksTable';
import LoadMoreBtn from '../components/LoadMoreBtn';
import LoadingScreen from '../components/LoadingScreen';
import ListFilter from '../components/ListFilter';
import FollowedFilter from '../components/FollowedFilter';
import { Typography, Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

const Tracks = () => {
  const [searchParams] = useSearchParams();
  const [genreQueryParam, setGenreQueryParam] = useState(
    searchParams.get('genre')
  );
  const [tracks, setTracks] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [paginationConfig, setPaginationConfig] = useState({
    order_by: 'track_meta.release_date',
    order_direction: 'desc',
    search: '',
    followed_filter: '',
  });
  const [followedFilter, setFollowedFilter] = useState(false);
  const api = useApi();

  useEffect(() => {
    if (genreQueryParam) {
      setPaginationConfig({ ...paginationConfig, genre: genreQueryParam });
    }
    loadTracks();
  }, [paginationConfig]);

  const loadTracks = async () => {
    if (loading) return;
    setLoading(true);

    const response = await api.get('/tracks', paginationConfig);
    if (response.ok) {
      setTracks(response.body.data);
      setPagination(response.body.pagination);
      setPage(1);
      setGenreQueryParam(null);
    } else {
      console.log(response);
    }
    setLoading(false);
  };

  const loadMore = async () => {
    setLoadingMore(true);
    const response = await api.get('/tracks', {
      ...paginationConfig,
      offset: 20 * page,
    });
    if (response.ok) {
      setTracks([...tracks, ...response.body.data]);
      setPagination(response.body.pagination);
      setPage(page + 1);
    } else {
      console.log(response);
    }
    setLoadingMore(false);
  };

  function onFilter(genre, sortBy, sortDirection) {
    if (genre === '' && genreQueryParam) {
      setGenreQueryParam('');
    }

    setPaginationConfig({
      ...paginationConfig,
      genre: genre,
      order_direction: sortDirection,
      order_by: `track_meta.${sortBy}`,
    });
  }

  const handleFollowedFilterChange = (event) => {
    const newFollowedFilter = event.target.checked;
    setFollowedFilter(newFollowedFilter);
    setPaginationConfig({
      ...paginationConfig,
      followed_filter: newFollowedFilter ? 'true' : '',
    });
  };

  return (
    <>
      {loading && <LoadingScreen />}
      <PageHeader backgroundArt={defaultArt} minHeight={350}>
        <Typography variant="h3" fontWeight="bold" mt={4}>
          Discover{' '}
          <Typography
            variant="h3"
            component="span"
            color="primary"
            fontWeight="bold"
          >
            Tracks
          </Typography>
        </Typography>
        <Typography mt={2}>Crate dig through new & old cuts</Typography>
      </PageHeader>
      <Box sx={{ padding: { xs: '20px', lg: '30px 0' }, textAlign: 'center' }}>
        <Box my={2}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
            }}
          >
            <FollowedFilter
              checked={followedFilter}
              onChange={handleFollowedFilterChange}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
              <ListFilter
                onFilter={onFilter}
                listType="tracks"
                genreQueryParam={genreQueryParam}
              />
            </Box>
          </Box>
          <TracksTable
            items={tracks}
            onTableInteraction={setPaginationConfig}
            tableInteractionConfig={paginationConfig}
            showGenreLink={false}
          />
        </Box>

        <LoadMoreBtn
          pagination={pagination}
          onLoadMoreClick={loadMore}
          loading={loadingMore}
        />
      </Box>
    </>
  );
};

export default Tracks;
